module.exports = __webpack_public_path__ + "static/media/banner-4.9cba83e3.webp";